import { render, staticRenderFns } from "./Remove.vue?vue&type=template&id=6fcf7d36&scoped=true"
import script from "./Remove.vue?vue&type=script&lang=ts"
export * from "./Remove.vue?vue&type=script&lang=ts"
import style0 from "./Remove.vue?vue&type=style&index=0&id=6fcf7d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcf7d36",
  null
  
)

export default component.exports